import { cn } from "@/lib/chillnn/cn";
import { formatDate } from "@/lib/dayjs/format-date";
import type { BillingStatus } from "@/lib/gql/__generated__/graphql";

import { Button } from "@/components/ui/button/button";

type CurrentTicketInfoProps = {
	billingStatus: BillingStatus;
	onAddTicketClick: () => void;
};

export const CurrentTicketInfo = ({ billingStatus, onAddTicketClick }: CurrentTicketInfoProps) => {
	const canShowValidDtEndPro = !!billingStatus.currentProBillingTicketName && !!billingStatus.validDtEndPro;

	return (
		<>
			<p className="col-span-2">{billingStatus.currentProBillingTicketName || "未選択"}</p>
			{canShowValidDtEndPro && (
				<div className="col-span-1">
					<p className="text-xs">有効期限</p>
					<p>{formatDate(billingStatus.validDtEndPro!, "YYYY年MM月DD日")}まで</p>
				</div>
			)}
			<div className={cn("flex justify-end", canShowValidDtEndPro ? "col-span-1" : "col-span-2")}>
				<Button type="button" variant="outline" onClick={onAddTicketClick}>
					追加する
				</Button>
			</div>
		</>
	);
};

CurrentTicketInfo.displayName = "CurrentTicketInfo";
